import { render } from "./BannerImage.vue?vue&type=template&id=04b22422&scoped=true"
import script from "./BannerImage.vue?vue&type=script&lang=js"
export * from "./BannerImage.vue?vue&type=script&lang=js"

import "./BannerImage.vue?vue&type=style&index=0&id=04b22422&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b22422"]])

export default __exports__